import React from 'react';
import PropTypes from 'prop-types';
import ImageSvg from '../image/ImageSvg';
import MemberProfileData from '../member/MemberProfileData';

const SectionSwitch = (props) => {
  const {
    active,
    onSwitch,
    percent,
    name,
    id,
    age,
    location,
    verified,
  } = props;
  // (e) => onSwitch('images', e)
  return (
    <div className="pr flex">
      <div className={`matches-search-section-switch tac pr btnGroupLarge--horizontal${!active ? ' mbm' : ''} ${active !== 'images' ? ' NO_matches-search-section-switch--negativeMargin' : ''}`}>
        <div
          className={`btn btn--iconLeft dib ${active === 'my' ? 'btn--matchSwitch btn--matchSwitchActive' : 'btn--matchSwitch'}`}
          role="button"
          tabIndex="0"
          onClick={(e) => onSwitch('my', e)}
          onKeyDown={(e) => onSwitch('my', e)}
        >
          <span className="btn-text">
            {`Anketa (${percent}%)`}
          </span>
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg="icon-notes"
                  iconClass="icon--full"
                />
              </span>
            </span>
          </span>
        </div>

        {/*
        <!-- Iespēja aizvērt anketu - šķiet ka nevajag -->
        <div
          className={`btn-close ${active === 'images' ? 'hide' : ''}`}
          role="button"
          tabIndex="0"
          onClick={(e) => onSwitch('images', e)}
          onKeyDown={(e) => onSwitch('images', e)}
        >
          <ImageSvg
            svg="icon-close"
            iconClass="icon--full"
          />
        </div> */}
        <div className="mrm dib" />
        <div
          className={`btn btn--iconLeft dib ${active === 'looking' ? 'btn--matchSwitch btn--matchSwitchActive' : 'btn--matchSwitch'}`}
          role="button"
          tabIndex="0"
          onClick={(e) => onSwitch('looking', e)}
          onKeyDown={(e) => onSwitch('looking', e)}
        >
          <span className="btn-text">
            {`${name} Meklē`}
          </span>
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg="icon-profilefind"
                  iconClass="icon--full"
                />
              </span>
            </span>
          </span>
        </div>
      </div>
      <MemberProfileData
        id={id}
        name={name}
        age={age}
        location={location}
        verified={verified}
      />
    </div>
  );
};

SectionSwitch.propTypes = {
  onSwitch: PropTypes.func.isRequired,
  active: PropTypes.string,
  percent: PropTypes.number,
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  age: PropTypes.number,
  location: PropTypes.string,
  verified: PropTypes.bool,
};

SectionSwitch.defaultProps = {
  active: null,
  percent: 0,
  name: '',
  age: 0,
  location: '',
  verified: false,
};

export default SectionSwitch;
